module.exports = __webpack_public_path__ + "static/beauty-products-by-category-sorting-tabs-section-a45f8e1453ac77253ce69282f8a70ffd.png";